// extracted by mini-css-extract-plugin
export default {"title":"_fa24afc8","description":"_58a0546e"};